/* eslint-disable no-unused-expressions, no-magic-numbers, curly */

/**
 *  Keyboard Focus class to handle focus on form elements
*/
class KeyBoardFocus {


    constructor() {

        this._addListeners();

    }

    /**
     * Add listeners
     *
     * @private
     */
    _addListeners() {
        document.addEventListener('keyup', event => {
            if (event.code !== 'Tab') return;

            this._removeFocusedClass();

            // Add the "keyboardFocused" class to the currently focused element
            document.activeElement.classList.add('keyboardFocused');
        });

        // Remove the class when the user interacts with the page with their mouse, or when the page looses focus
        document.addEventListener('click', this._removeFocusedClass);
        document.addEventListener('focusout', this._removeFocusedClass);

    }

    // Remove the "keyboardFocused" class from any elements that have it
    // eslint-disable-next-line class-methods-use-this
    _removeFocusedClass() {
        const previouslyFocusedElement = document.getElementsByClassName('keyboardFocused')[0];
        if (previouslyFocusedElement) previouslyFocusedElement.classList.remove('keyboardFocused');
    }

}

export default KeyBoardFocus;

/* eslint-enable */
